import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { Link, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import { getErrorMessage } from "../../lib/apiClient";
import { forgotPassword } from "./authApi";
import AuthShell from "./AuthShell";

export default function ForgotPasswordPage() {
  const [searchParams] = useSearchParams();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { email: searchParams.get("email") ?? "" } });

  const mutation = useMutation({
    mutationFn: ({ email }) => forgotPassword(email),
    // Always succeed in the UI (no account enumeration) — the API returns 202.
  });

  return (
    <AuthShell
      icon={<KeyRound className="h-7 w-7 text-brand-600" />}
      title="Reset your password"
      subtitle="We’ll email you a reset link."
    >
      {mutation.isSuccess ? (
        <p className="text-center text-sm text-slate-600">
          If an account exists for that address, a password-reset link is on its
          way. Check your inbox.
        </p>
      ) : (
        <form
          className="space-y-4"
          onSubmit={handleSubmit((v) => mutation.mutate(v))}
          noValidate
        >
          <Input
            label="Email"
            type="email"
            autoComplete="email"
            error={errors.email?.message ?? getErrorMessage(mutation.error, "")}
            {...register("email", { required: "Email is required" })}
          />
          <Button type="submit" className="w-full" loading={mutation.isPending}>
            Send reset link
          </Button>
        </form>
      )}
      <p className="mt-6 text-center text-sm text-slate-500">
        <Link
          to="/login"
          className="font-medium text-brand-600 hover:text-brand-700"
        >
          Back to sign in
        </Link>
      </p>
    </AuthShell>
  );
}
